import { spacer40 } from '@spotify-internal/encore-web/core';
import React from 'react';
import styled from 'styled-components';
import { NavBarHeight } from '../../../constants';
import { Grid, TWO_COLUMN_MAX_WIDTH } from './Grid';
const StyledGrid = styled(Grid) `
  padding-top: calc(32px + ${NavBarHeight}px);
  padding-bottom: 52px;
  & > * {
    grid-column-start: span 3;
    @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
      grid-column-start: span 1;
    }
  }
  grid-row-gap: ${spacer40};
`;
export const CategoryMenu = ({ column1, column2, column3, column4, }) => {
    return (React.createElement(StyledGrid, null,
        column1,
        column2,
        column3,
        column4));
};
//# sourceMappingURL=index.js.map